import type { MeetingType } from "meetings/shared/constants";

/**
 * Identifies a meeting on "Mijn feedback": ids are only unique per meeting
 * type. Also the `?open=` value that opens that meeting's card.
 */
export const meetingKey = (meeting: {
  meetingType: MeetingType;
  id: number | string;
}): string => `${meeting.meetingType}-${meeting.id}`;
